import React, { useEffect, useState } from "react";
import AddScheduledScreen from "./scheduledScreens/AddScheduledscreen";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import ScheduleCreativePage from "./scheduledScreens/ScheduleCreativeScreen";
import { TagProvider } from "../../../context/TagContext";
import { ScreenProvider } from "../../../context/ScreenContext";
import ScheduledCreativesListPage from "./scheduledScreens/ScheduledCreativesList";
import {
  ScheduledCreativesProvider,
  useScheduledCreatives,
} from "../../../context/ScheduledCreativesContext";
import ReplaceScheduledCreativeScreen from "./scheduledScreens/ReplaceScheduledCreativeScreen";

// Loading component
const LoadingScreen: React.FC = () => (
  <div className="w-full h-full flex items-center justify-center">
    <div className="text-gray-500">Loading...</div>
  </div>
);

// Component to handle conditional routing logic
const ConditionalRouting: React.FC = () => {
  const { scheduledCreatives } = useScheduledCreatives();
  const location = useLocation();
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  // Allow initial loading to complete before making routing decisions
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsInitialLoad(false);
    }, 100); // Small delay to ensure localStorage has been read

    return () => clearTimeout(timer);
  }, []);

  // Show loading during initial load to prevent flicker
  if (isInitialLoad) {
    return <LoadingScreen />;
  }

  // Function to determine default redirect
  const getDefaultRedirect = () => {
    return scheduledCreatives.length > 0
      ? "/scheduled/list"
      : "/scheduled/add-scheduled";
  };

  return (
    <Routes>
      {/* Default route - redirect based on data availability */}
      <Route
        path="/"
        element={<Navigate to={getDefaultRedirect()} replace />}
      />

      {/* Explicit routes */}
      <Route path="/add-scheduled" element={<AddScheduledScreen />} />
      <Route path="/schedule-creative" element={<ScheduleCreativePage />} />
      <Route path="/list" element={<ScheduledCreativesListPage />} />
      <Route
        path="/replace/:creativeId"
        element={<ReplaceScheduledCreativeScreen />}
      />

      {/* Catch-all route for any undefined paths */}
      <Route
        path="*"
        element={<Navigate to={getDefaultRedirect()} replace />}
      />
    </Routes>
  );
};

const Scheduled: React.FC = () => {
  return (
    <ScheduledCreativesProvider>
      <TagProvider>
        <ScreenProvider>
          <ConditionalRouting />
        </ScreenProvider>
      </TagProvider>
    </ScheduledCreativesProvider>
  );
};

export default Scheduled;
